export * from './copy_icon';
